import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { Group, User } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';


@Component({
    selector: 'app-user-node',
    templateUrl: './user-node.component.html',
    styleUrls: ['./user-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserNodeComponent extends NodeComponent {
    static current: User | Group;

    protected get nodeType(): string | undefined {
        return 'user';
    }

    private iconRoot = 'groups';
    private iconGroup = 'people_alt';
    private iconType = 'person';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model?.node instanceof Group) {
                if (model.node.parentId) {
                    this.icon = this.iconGroup;
                } else {
                    this.icon = this.iconRoot;
                }
            } else if (model?.node instanceof User) {
                this.icon = this.iconType;
                const user = model.node as User;
                if (user._system) {
                    model.solo.editable = false;
                }
            }
        });
    }
}
